import { selectAll, selectDoc } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class InfoSlider {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.buttonSwap = selectAll('[data-button]');
    this.sliderEl = selectDoc('[data-info-slider]');
    this.sliderLeft = selectDoc('[data-info-left]');
    this.sliderRight = selectDoc('[data-info-right]');
  }

  render() {
    this.setButton();
    this.slider();
  }

  slider() {
    let slider = new Swiper(this.sliderEl, {
      slidesPerView: '1',
      centeredSlides: true,
      loop:false,
      resistanceRatio: 1,
      watchOverflow: true
    });

    this.sliderRight.addEventListener('click', () => {
      slider.slideNext();
    })

    this.sliderLeft.addEventListener('click', ()=> {
      slider.slidePrev();
    })

  }

  setButton = () => {
    console.log(this.buttonSwap);
    for(let button of this.buttonSwap) {
      button.addEventListener('click', () => {
        button.closest('[data-buttons]').querySelector('.active').classList.remove('active');
        button.classList.add('active');
        button.closest('[data-images]').querySelectorAll('[data-index]').forEach((element) => {
          button.dataset.index === element.dataset.index ? element.classList.remove('hide') : element.classList.add('hide');
        })
      })
    }
  }
}